import script from "./SettingsEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsEmail.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsEmail.vue?vue&type=style&index=0&id=3ee901ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ee901ca"]])

export default __exports__